import { View } from '@/styles/reactnative';
import { ThemeContext } from '@/theme/ThemeProvider.tsx';
import { useContext } from 'react';
import styled from 'styled-components';
import DarkProfile from './assets/DarkProfile.svg?react';
import Profile from './assets/Profile.svg?react';
import AuthHeaderButton from './AuthHeaderButton';
import { AuthHeaderMobile } from './styles';

const AuthHeaderMenu = () => {
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';

  return (
    <View
      style={{
        flexDirection: 'row',
        paddingInline: '1rem',
        marginRight: 0,
      }}
    >
      <AuthHeaderMobile>
        {/* <AuthHeaderButton
					type={'asset'}
					label={t('@/assets')}
					width={50}
				/>
				<AuthHeaderButton
					type={'deposit'}
					label={t('DepositWithdraw')}
					width={80}
				/> */}
        {/* <AuthHeaderButton
					type={'qbit'}
					label={t('orders')}
					width={70}
					onPress={() => {
						goTo(nav, '/orders')
					}}
				/> */}
      </AuthHeaderMobile>

      <AuthHeaderButton
        type={'user'}
        Icon={() => <IconSVG as={theme === 'light' ? DarkProfile : Profile} />}
      />
      {/*<AuthHeaderButton type={"noti"} Icon={() => <IconSVG as={theme === 'light' ? DarkNotification : Notification} />} />*/}
    </View>
  );
};

export default AuthHeaderMenu;

const IconSVG = styled.svg``;
